import { render, staticRenderFns } from "./TeamMemberPhoto.vue?vue&type=template&id=ec155392&"
import script from "./TeamMemberPhoto.vue?vue&type=script&lang=js&"
export * from "./TeamMemberPhoto.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports